import React from "react";

function operation({ clickedArray, handleClick }) {
  return (
    <div>
      {clickedArray.map((item, index) => {
        if (index === 0) {
          if (item === "") {
            return (
              <div
                key={index}
                className="op_line"
                onClick={() => handleClick(index)}
              ></div>
            );
          } else {
            return (
              <div
                key={index}
                className="op_line clicked"
                onClick={() => handleClick(index)}
              ></div>
            );
          }
        } else if (index === 1) {
          if (item === "") {
            return (
              <div
                key={index}
                className="oq_line"
                onClick={() => handleClick(index)}
              ></div>
            );
          } else {
            return (
              <div
                key={index}
                className="oq_line clicked"
                onClick={() => handleClick(index)}
              ></div>
            );
          }
        } else if (index === 2) {
          if (item === "") {
            return (
              <div
                key={index}
                className="or_line"
                onClick={() => handleClick(index)}
              ></div>
            );
          } else {
            return (
              <div
                key={index}
                className="or_line clicked"
                onClick={() => handleClick(index)}
              ></div>
            );
          }
        } else if (index === 3) {
          if (item === "") {
            return (
              <div
                key={index}
                className="ol_line"
                onClick={() => handleClick(index)}
              ></div>
            );
          } else {
            return (
              <div
                key={index}
                className="ol_line clicked"
                onClick={() => handleClick(index)}
              ></div>
            );
          }
        } else if (index === 4) {
          if (item === "") {
            return (
              <div
                key={index}
                className="oe_line"
                onClick={() => handleClick(index)}
              ></div>
            );
          } else {
            return (
              <div
                key={index}
                className="oe_line clicked"
                onClick={() => handleClick(index)}
              ></div>
            );
          }
        } else {
          return (
            <div
              key={index}
              className="s_line"
              onClick={() => handleClick(index)}
            >
              {" "}
            </div>
          );
        }
      })}
    </div>
  );
}

export default operation;
